module.exports = __webpack_public_path__ + "img/ic_hamburguer_blue.114e11a4.svg";